module.exports = __webpack_public_path__ + "img/offline-ship.a8c7e589.svg";